import { optionSubcategory_premium } from './premiumDashboardSubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import { PremiumStorageOption } from 'owa-premium-storage-option';
import { SubscriptionOption } from 'owa-subscription-option';
import { AdvancedSecurityOption } from 'owa-advanced-security-option';
import { getAccountInformation } from 'owa-storage-option';

let premiumDashboardSubCategory: OptionSubCategory = {
    key: 'Premium',
    titleStringKey: optionSubcategory_premium,
    options: [PremiumStorageOption, SubscriptionOption, AdvancedSecurityOption],
    onSelected: () => {
        return getAccountInformation();
    },
};

export default premiumDashboardSubCategory;
